function Diacritics() {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 64 64"
        fill="none"
    >
      <rect width="64" height="64" fill="#FFFFFF" />

      <text
          x="14"
          y="48"
          fontFamily="Arial, sans-serif"
          fontSize="38"
          fill="currentColor"
          fontWeight="bold"
      >
        ض
      </text>

      <text
          x="28"
          y="40"
          fontFamily="Arial, sans-serif"
          fontSize="38"
          fill="currentColor"
      >
        َ</text>

    </svg>
  );
}

export default Diacritics;
